import React from "react";
// These values are only here to aid in IDE autocompletion
export default React.createContext({});